import React from "react";
import { CalendarDays, Clock } from "lucide-react";
import { Card } from "@/components/ui/card";
import AttachmentCard from "./AttachmentCard";
import { formatDateAndTime } from "@/utils/dateFormat";

export type Transaction = {
  id: number;
  collectionId: number;
  createdBy: number;
  fileId: number;
  message: string;
  status: string;
  updatedAt: string;
  type: string;
  amount: number;
  amountLetter: string;
  createdAt: string;
  File: any;
};

type Props = {
  transaction: Transaction;
  Customer: Client | undefined;
  Collector: Employee | undefined;
  CreatedBy: Employee | undefined;
  type: string;
};

const ActivityLogCard: React.FC<Props> = ({
  type,
  transaction,
  Customer,
  Collector,
  CreatedBy,
}) => {
  return (
    <Card className="p-4 shadow-none border border-primary/30">
      <div className="flex gap-6">
        <div>
          <span
            className={`
            ${
              type === "collect"
                ? "text-[#679EF1] border-[#679EF1]"
                : "text-[#97B226] border-[#97B226]"
            }
            px-4 py-1  border  rounded-[5px] text-sm  font-semibold`}
          >
            {type}
          </span>
        </div>
        <div className="flex flex-col items-start gap-2">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <CalendarDays className="h-4 w-4" />
              <span>{formatDateAndTime(transaction.createdAt).date}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-4 w-4" />
              <span>{formatDateAndTime(transaction.createdAt).time}</span>
            </div>
          </div>
          <p className="text-sm">
            <span className="text-primary font-semibold">
              {Collector?.fullname}
            </span>{" "}
            {transaction.type}ed{" "}
            <span className="text-primary font-semibold">
              {transaction.amount} {""} DZD {""}
              {type === "collect" ? (
                <span>
                  from{" "}
                  <span className="italic text-black">
                    {Customer?.commercial_name}
                  </span>
                </span>
              ) : null}
            </span>
          </p>
          {/* <AttachmentCard key={transaction.id} item={transaction} /> */}
        </div>
      </div>
    </Card>
  );
};

export default ActivityLogCard;
